import { ConfigProvider } from "antd";
import vi from "antd/locale/vi_VN";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Router, Switch } from "react-router-dom";
import { globalStores } from "./GlobalStores";
import history from "./history";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Verification from "./pages/Verification";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { UNAUTH_ROUTE } from "./common/constants";

const LOCALE = { vi };

const App = observer(() => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    globalStores.setT(t);
  }, [t]);

  return (
    <ConfigProvider locale={LOCALE[i18n.language]} theme={{ token: { colorPrimary: "#5e72e4" } }}>
      <Router history={history}>
        <Switch>
          <Route path={UNAUTH_ROUTE.LOGIN_VPBANK}>
            <Login sso />
          </Route>
          <Route path={UNAUTH_ROUTE.LOGIN}>
            <Login />
          </Route>
          {/* TODO: PROD */}
          {process.env.REACT_APP_ENVIRONMENT !== "PRODUCTION" && (
            <Route path={UNAUTH_ROUTE.REGISTER}>
              <Register />
            </Route>
          )}
          {process.env.REACT_APP_ENVIRONMENT !== "PRODUCTION" && (
            <Route path={UNAUTH_ROUTE.VERIFICATION}>
              <Verification />
            </Route>
          )}
          <Route path={UNAUTH_ROUTE.FORGOT_PASSWORD}>
            <ForgotPassword />
          </Route>
          <Route path={UNAUTH_ROUTE.RESET_PASSWORD}>
            <ResetPassword />
          </Route>
          <Route history={history} path="/">
            <Dashboard />
          </Route>
        </Switch>
      </Router>
    </ConfigProvider>
  );
});
export default App;
